/**
 * 顶部提示
 */
import React from 'react';
import { Alert } from 'antd';
import { NoticeInfo } from '@/redux/reducers/reservation/base.d';

import styles from './index.module.scss';

const Index: React.FC<NoticeInfo> = (props) => {
  const { type, message } = props;
  if (!message) return null;
  return (
    <div className={styles.noticeContainer}>
      <Alert message={message} type={type} showIcon />
    </div>
  );
};

export default Index;
